import { Box, Flex, Image } from '@chakra-ui/react'
import type { QuoteRating } from 'BrokerTsLib/src/dtos'
import { useEffect, useState } from 'react'

import starEmptyIcon from '../../images/star-empty-icon.svg'
import starFilledIcon from '../../images/star-filled-icon.svg'

export const Stars = ({
  rating = 0,
  isDisabled = false,
  onChange,
}: {
  rating?: QuoteRating
  isDisabled?: boolean
  onChange?: (rating: QuoteRating) => void
}) => {
  const [currentRating, setCurrentRating] = useState(rating as number)
  const [currentHoverRating, setCurrentHoverRating] = useState(0)
  const maxStars = 3
  const starsArray = Array.from(Array(maxStars).keys())

  const handleClick = (index: number) => {
    if (isDisabled) return

    let newCurrentRating = index

    // Clicking current star will reset rating to 0
    if (index === currentRating) {
      newCurrentRating = 0
    }

    setCurrentRating(newCurrentRating)
    onChange?.(newCurrentRating as QuoteRating)
  }

  const handleMouseEnter = (index: number) => {
    if (isDisabled) return

    setCurrentHoverRating(index)
  }

  const handleMouseLeave = () => {
    if (isDisabled) return

    if (rating === 0) {
      setCurrentHoverRating(0)
    } else {
      setCurrentRating(rating as number)
    }
  }

  const sx = {
    cursor: isDisabled ? 'default' : 'pointer',
  }

  useEffect(() => {
    setCurrentRating(rating as number)
  }, [rating])

  return (
    <Flex sx={{ h: 5, gap: 0 }}>
      {starsArray.map((starIndex) => {
        if (starIndex < currentRating || starIndex < currentHoverRating) {
          return (
            <Box
              key={starIndex}
              sx={sx}
              onClick={() => handleClick(starIndex + 1)}
              onMouseEnter={() => handleMouseEnter(starIndex + 1)}
              onMouseLeave={() => handleMouseLeave()}
            >
              <Image src={starFilledIcon} alt="" />
            </Box>
          )
        }

        return (
          <Box
            key={starIndex}
            sx={sx}
            onClick={() => handleClick(starIndex + 1)}
            onMouseEnter={() => handleMouseEnter(starIndex + 1)}
            onMouseLeave={() => handleMouseLeave()}
          >
            <Image src={starEmptyIcon} alt="" />
          </Box>
        )
      })}
    </Flex>
  )
}
